<div class="consultorio-privado-cadastro-container">
    @if (carregando()) {
        <div class="feedback">Carregando dados...</div>
    } @else if (erroConsulta()) {
        <div class="feedback erro">{{ erroConsulta() }}</div>
    } @else if (!dados()) {
        <div class="feedback">Nenhum dado disponível para este protocolo.</div>
    } @else {
        @if (abaSelecionada() === EAbaConsultorioPrivado.DADOS) {
            <div class="secoes">
                @for (secao of secoesDados; track secao.titulo) {
                    <app-card-content [headerColor]="false" [title]="secao.titulo" [icon]="iconeDaSecao(secao.titulo)" [subtitle]="subtituloDaSecao(secao.titulo)">
                        <div class="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-3">
                            @for (campo of secao.campos; track campo.label) {
                                <ng-container [ngTemplateOutlet]="campoDaSecao" [ngTemplateOutletContext]="{ secao: secao, campo: campo }" />
                            }
                        </div>
                    </app-card-content>
                }

                <app-card-content [headerColor]="false" [title]="'Anexos'" [icon]="iconeDaSecao('Anexos')" [subtitle]="subtituloDaSecao('Anexos')">
                    <div class="grid grid-cols-1 md:grid-cols-2 gap-3">
                        <article class="campo campo--anexo">
                            <span class="campo-label">Anexo Alvará</span>
                            @if (possuiAnexoAlvara()) {
                                <button type="button" class="campo-link-botao" (click)="onVisualizarAnexoAlvara($event)" aria-label="Visualizar anexo alvará" title="Visualizar anexo alvará">
                                    <i class="pi pi-paperclip"></i>
                                    <span>Visualizar anexo</span>
                                </button>
                            } @else {
                                <strong class="campo-valor">-</strong>
                            }
                        </article>

                        <article class="campo campo--anexo">
                            <span class="campo-label">Anexo Registro Sanitário</span>
                            @if (possuiAnexoRegistroSanitario()) {
                                <button type="button" class="campo-link-botao" (click)="onVisualizarAnexoRegistroSanitario($event)" aria-label="Visualizar anexo registro sanitário" title="Visualizar anexo registro sanitário">
                                    <i class="pi pi-paperclip"></i>
                                    <span>Visualizar anexo</span>
                                </button>
                            } @else {
                                <strong class="campo-valor">-</strong>
                            }
                        </article>
                    </div>
                </app-card-content>
            </div>
        }

        @if (abaSelecionada() === EAbaConsultorioPrivado.ENDERECO) {
            <div class="secoes">
                @if (secaoEndereco; as secaoEndereco) {
                    <app-card-content [headerColor]="false" [title]="secaoEndereco.titulo" [icon]="iconeDaSecao(secaoEndereco.titulo)" [subtitle]="subtituloDaSecao(secaoEndereco.titulo)">
                        <div class="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-3">
                            @for (campo of secaoEndereco.campos; track campo.label) {
                                <ng-container [ngTemplateOutlet]="campoDaSecao" [ngTemplateOutletContext]="{ secao: secaoEndereco, campo: campo }" />
                            }
                        </div>
                    </app-card-content>
                }

                <app-card-content [headerColor]="false" [title]="'Telefones relacionados ao endereco'" [icon]="iconeDaSecao('Telefones relacionados ao endereco')" [subtitle]="subtituloDaSecao('Telefones relacionados ao endereco')">
                    <p-table [value]="telefones()" responsiveLayout="scroll">
                        <ng-template pTemplate="body" let-row>
                            <tr>
                                <td>{{ getTelefoneTipoLabel(row.tipo) }}</td>
                                <td>{{ row.ddd }}</td>
                                <td>{{ row.telefone }}</td>
                                <td>{{ row.ramal }}</td>
                                <td>{{ row.observacao }}</td>
                            </tr>
                        </ng-template>
                    </p-table>
                </app-card-content>
            </div>
        }

        @if (abaSelecionada() === EAbaConsultorioPrivado.COMP) {
            <app-card-content [headerColor]="false" [title]="'Compartilhamento'" [icon]="iconeDaSecao('Compartilhamento')" [subtitle]="subtituloDaSecao('Compartilhamento')">
                <p-table [value]="compartilhamentos()" responsiveLayout="scroll">
                    <ng-template pTemplate="header">
                        <tr>
                            <th>UF</th>
                            <th>Nome</th>
                            <th>Entrada</th>
                            <th>Saída</th>
                        </tr>
                    </ng-template>
                    <ng-template pTemplate="body" let-row>
                        <tr>
                            <td>{{ row.uf }}</td>
                            <td>{{ row.nome }}</td>
                            <td>{{ row.entrada }}</td>
                            <td>{{ row.saida }}</td>
                        </tr>
                    </ng-template>
                </p-table>
            </app-card-content>
        }

        @if (abaSelecionada() === EAbaConsultorioPrivado.ESP) {
            <app-card-content [headerColor]="false" [title]="'Especialidades'" [icon]="iconeDaSecao('Especialidades')" [subtitle]="subtituloDaSecao('Especialidades')">
                <p-table [value]="especialidades()" responsiveLayout="scroll">
                    <ng-template pTemplate="header">
                        <tr>
                            <th>Especialidade</th>
                            <th>Área de Atuação</th>
                            <th>Data início</th>
                            <th>Data fim</th>
                        </tr>
                    </ng-template>
                    <ng-template pTemplate="body" let-row>
                        <tr>
                            <td>{{ row.especialidade }}</td>
                            <td>{{ row.areaAtuacao }}</td>
                            <td>{{ row.dataInicio }}</td>
                            <td>{{ row.dataFim }}</td>
                        </tr>
                    </ng-template>
                </p-table>
            </app-card-content>
        }

        @if (abaSelecionada() === EAbaConsultorioPrivado.HORA) {
            <app-card-content [headerColor]="false" [title]="'Horarios de Funcionamento do Consultorio'" [icon]="iconeDaSecao('Horarios de Funcionamento do Consultorio')" [subtitle]="subtituloDaSecao('Horarios de Funcionamento do Consultorio')">
                <p-table [value]="horariosFuncionamento()" responsiveLayout="scroll">
                    <ng-template pTemplate="header">
                        <tr>
                            <th>Dia da Semana</th>
                            <th>Horário Manhã (Início)</th>
                            <th>Horário Manhã (Fim)</th>
                            <th>Horário Tarde (Início)</th>
                            <th>Horário Tarde (Fim)</th>
                        </tr>
                    </ng-template>
                    <ng-template pTemplate="body" let-row>
                        <tr>
                            <td>{{ row.diaSemana }}</td>
                            <td>{{ row.manhaInicio }}</td>
                            <td>{{ row.manhaFim }}</td>
                            <td>{{ row.tardeInicio }}</td>
                            <td>{{ row.tardeFim }}</td>
                        </tr>
                    </ng-template>
                </p-table>
            </app-card-content>
        }
    }
</div>

<!--
    Um campo, nas duas formas. Template único porque as seções de dados e a de endereço desenham o
    MESMO campo — antes eram dois blocos iguais, e um ajuste em um deles deixava o outro para trás.

    `secaoEhDeDados` (vocabulário compartilhado) decide a forma. Nas seções de dados o campo sai como controle DESABILITADO:
    é a aparência do detalhamento de pré-prestador, e desabilitado porque esta tela é de leitura —
    campo habilitado prometeria uma edição que não existe aqui.

    `for`/`id` ligam rótulo e controle (o id junta seção e rótulo, que se repetem entre seções). Nas
    seções que seguem como texto, o par continua sendo `campo-label`/`campo-valor`, e a situação
    mantém o badge que a colore.
-->
<ng-template #campoDaSecao let-secao="secao" let-campo="campo">
    @if (secaoEhDeDados(secao.titulo)) {
        <div class="field">
            <label class="font-semibold block mb-2" [for]="idDoCampo(secao, campo)">{{ campo.label }}</label>
            <input pInputText [id]="idDoCampo(secao, campo)" class="w-full" [value]="valorCampo(campo)" disabled />
        </div>
    } @else {
        <article
            class="campo"
            [class.campo--destaque-identificacao]="campo.label.toLowerCase().trim().startsWith('cpf') || campo.label.toLowerCase().trim().startsWith('crm') || campo.label.toLowerCase().includes('cnpj')"
            [class.campo--situacao]="ehCampoBadge(campo)"
        >
            <span class="campo-label">{{ campo.label }}</span>
            @if (ehCampoBadge(campo)) {
                <span [class]="'campo-badge situacao-' + situacaoClassePorTexto(valorCampo(campo))">
                    {{ rotuloBadgeSituacao(campo.label, valorCampo(campo)) }}
                </span>
                @if (campo.chave === 'situacao' && protocoloSelecionado()?.inPago === false) {
                    <span class="campo-badge campo-badge-pagamento nao-pago">Não pago</span>
                }
            } @else {
                <strong class="campo-valor">{{ valorCampo(campo) }}</strong>
            }
        </article>
    }
</ng-template>

<p-dialog
    appDialogoPadrao="pi pi-paperclip"
    descricao="Documento anexado ao registro."
    [visible]="exibirDialogAnexo()"
    (visibleChange)="exibirDialogAnexo.set($event)"
    [style]="{ width: '90vw', maxWidth: '1200px' }"
    header="Visualização de anexo"
    (onHide)="fecharDialogAnexo()"
>
    @if (blobAnexo(); as blobAnexo) {
        <app-visualizador-pdf [src]="blobAnexo" [fileName]="nomeArquivoAnexo()" [showAll]="false"></app-visualizador-pdf>
    } @else {
        <div class="anexo-feedback">Nenhum anexo disponível para visualização.</div>
    }
</p-dialog>
